import React from "react";
import { formatValidationErrorLabel, getValidationErrorKeys } from "../utils/validationUi";

function ValidationSummary({ errors, onJumpToFirst }) {
  const keys = getValidationErrorKeys(errors);
  if (!keys.length) return null;

  const preview = keys.slice(0, 3).map(formatValidationErrorLabel);

  return (
    <div className="cms-validation-banner" role="alert" aria-live="polite">
      <div className="cms-validation-banner__icon" aria-hidden="true">
        <i className="mdi mdi-alert-circle-outline" />
      </div>
      <div className="cms-validation-banner__body">
        <p className="cms-validation-banner__title">
          {keys.length} {keys.length === 1 ? "field needs" : "fields need"} attention before you can
          save.
        </p>
        <p className="cms-validation-banner__hint">
          Errors are shown under each input. First: {preview.join("; ")}
          {keys.length > 3 ? ` (+${keys.length - 3} more)` : ""}
        </p>
      </div>
      {onJumpToFirst ? (
        <button type="button" className="cms-validation-banner__action" onClick={onJumpToFirst}>
          Go to first error
        </button>
      ) : null}
    </div>
  );
}

export default ValidationSummary;
